import { useState } from "react";
import { Link } from "react-router-dom";

import { useCountdown } from "../Hooks/useCountdown";
import styles from "./news.modal.module.css";

const NewsModal = () => {
	const [modalVisible, setModalVisible] = useState(
		Date.now() < new Date("2026-06-30T00:00:01").getTime()
	);
	const {
		remainingDays,
		remainingHours,
		remainingMinutes,
		remainingSeconds
	} = useCountdown(new Date("2026-06-30T00:00:01").getTime());

	// checking if the user has visited the page and has seen the news modal //
	// useEffect(() => {
	// 	if (!localStorage.getItem("modalShown")) {
	// 	setModalVisible(true);
	// 	localStorage.setItem("modalShown", "true");
	// 	}
	// }, []);

	// const downloadImage = () => {
	// 	const link = document.createElement("a");
	// 	link.href = ESIRSJTBTIN;
	// 	link.download = "ESIRS JTB TIN";
	// 	document.body.appendChild(link);
	// 	link.click();
	// 	document.body.removeChild(link);
	// };

	return (
		<>
			{modalVisible && (
				<>
					<div
						className={`${styles.modalOverlay} ${
							modalVisible ? styles.visible : styles.invisible
						}`}
						onClick={() => setModalVisible(false)}
					></div>
					<div
						className={styles.modalContent}
						onClick={(e) => e.stopPropagation()}
						aria-label="announcement modal"
					>
						<div className={styles.top}>
							<button onClick={() => setModalVisible(false)}>
								&times;
							</button>
							<div className={styles.top__bottom}>
								<div className={styles.top__bottom_left}>
									<span>!</span>
									<span>Important Notice</span>
									<h1>E-filing for 2026 is now open!</h1>
									<p>
										Organizations are required by law to
										file tax returns for employee emoluments
										paid between January - December 2025.
										Ensure you file and pay taxes promptly
										to avoid penalties.
									</p>
								</div>
								<div>
									<span>Filing On or Before</span>
									<span>June 30th, 2026</span>
								</div>
							</div>
						</div>
						<div className={styles.body}>
							<div className={styles.steps}>
								<h2>Steps to File for Returns</h2>
								<ol>
									<li>
										<span>1</span>
										<span>
											Login to{" "}
											<b>
												<Link to="https://www.irs.en.gov.ng/login">
													www.irs.en.gov.ng
												</Link>
											</b>{" "}
											using your organization's ESBN and
											password.
										</span>
									</li>
									<li>
										<span>2</span>
										<span>
											Click <b>"E-Filing"</b> and select{" "}
											<b>“PAYE Filing”</b>.
										</span>
									</li>
									<li>
										<span>3</span>
										<span>
											Click on <b>"File Returns"</b> and
											choose your filing frequency
											(Yearly, Monthly, or Period).
										</span>
									</li>
									<li>
										<span>4</span>
										Specify the filing period (Year, Month,
										or custom Period).
									</li>
									<li>
										<span>5</span>
										Download the template, fill it out
										correctly, upload it, and click Submit.
									</li>
									<li>
										<span>6</span>
										Enter filer details and upload a
										signature.
									</li>
									<li>
										<span>7</span>
										Include payment receipt numbers for the
										filing year.
									</li>
									<li>
										<span>8</span>
										Upload receipts and click "FILE
										RETURNS".
									</li>
									<li>
										<span>9</span>
										Preview details, check the box for final
										submission, and generate the H1 Form.
									</li>
									<li>
										<span>10</span>
										Note and make payments for any negative
										variances.
									</li>
									<li>
										<span>11</span>
										Wait for final approval by the EIRS.
									</li>
								</ol>
							</div>
							<div className={styles.grey__area}>
								<h2>Before You Begin</h2>
								<ol>
									<li>
										Ensure that the email address and phone
										number linked to your ESBN are active
										and correct.
									</li>
									<li>
										Make sure you have your current ESBN
										password handy.
									</li>
								</ol>
								<div
									className={styles.forgot__password_section}
								>
									<h2>Forgot Your Password?</h2>
									<ul>
										<li>
											<i
												style={{
													marginRight: "12px",
													display: "inline-block",
													fontStyle: "normal"
												}}
											>
												🌐
											</i>
											<span>
												<span>Step 1</span>
												Visit{" "}
												<Link to="/login">
													https://irs.en.gov.ng/login
												</Link>
											</span>
										</li>
										<li>
											<i
												style={{
													marginRight: "12px",
													display: "inline-block",
													fontStyle: "normal"
												}}
											>
												🔒
											</i>
											<span>
												<span>Step 2</span>
												Click on "Forgot Password"
											</span>
										</li>
										<li>
											<i
												style={{
													marginRight: "12px",
													display: "inline-block",
													fontStyle: "normal"
												}}
											>
												📝
											</i>
											<span>
												<span>Step 3</span>
												Enter your ESBN and click
												"Submit"
											</span>
										</li>
									</ul>
								</div>
							</div>
							<p className={styles.info}>
								Organizations are mandated in line with the
								extant provisions of the Personal Income Tax Act
								2004 (as amended) to file the returns on all
								emoluments paid to their employees from Jan -
								Dec 2025 and ensure that due taxes are paid
								immediately!!!!!
							</p>
							<div className={styles.countdown}>
								<h2>
									2026 COMPANY ANNUAL TAX RETURNS FILING ENDS
									IN
								</h2>
								<div>
									<div>
										<span>Days</span>
										<span>{remainingDays}</span>
									</div>
									<div>
										<span>Hours</span>
										<span>{remainingHours}</span>
									</div>
									<div>
										<span>Minutes</span>
										<span>{remainingMinutes}</span>
									</div>
									<div>
										<span>Seconds</span>
										<span>{remainingSeconds}</span>
									</div>
								</div>
							</div>
							<p className={styles.footer}>
								<span>
									ESIRS - Enugu State Internal Revenue Service
								</span>{" "}
								<span>
									Need help? Contact support at{" "}
									<a href="tel:08075625555">08075625555</a> or{" "}
									<a href="mailto:esirs@enugustate.gov.ng">
										esirs@enugustate.gov.ng
									</a>
								</span>
							</p>
						</div>
					</div>
				</>
			)}
		</>
	);
};

export default NewsModal;
